import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-early-activation-banner',
  template: require('./early-activation-banner.component.html'),
  styles: [`
    .early-activation-banner {
      background-color: #fff4ce;
      border: 1px solid #f1d176;
      border-radius: 4px;
      padding: 12px 16px;
      margin-bottom: 16px;
      color: #222;
    }
    .early-activation-banner-title {
      font-weight: 700;
      letter-spacing: 0.2px;
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .early-activation-banner-icon {
      color: #2e7d32;
      font-size: 20px;
      width: 20px;
      height: 20px;
    }
    .early-activation-banner-subtitle {
      font-size: 14px;
      line-height: 1.4;
      padding-left: 28px;
    }
  `]
})
export class EarlyActivationBannerComponent {
  @Input() verificationAndApprovalText = '';
  @Input() notMandatoryDocLabels: string[] = [];
}
